import { Button, ButtonProps, CircularProgress } from '@material-ui/core'
import React from 'react'
import { classes } from '../../../utils/css'
import styles from './AppButton.module.css'

export type AppButtonProps = ButtonProps & {
  loading?: boolean
}

function AppButton(
  props: AppButtonProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  return (
    <div className={styles.wrapper}>
      <Button
        ref={ref}
        {...props}
        className={
          props.loading
            ? classes(styles.button, styles.disabled, props.className || '')
            : classes(styles.button, props.className || '')
        }
        onClick={(event) => {
          event.preventDefault()
          props.onClick && props.onClick(event)
        }}
      />
      {props.loading && (
        <CircularProgress size={20} className={styles.buttonProgress} />
      )}
    </div>
  )
}

export default React.forwardRef(AppButton)
